import { Space } from 'antd'
import _ from 'lodash'
import React from 'react'
import styled, { css } from 'styled-components'

import { Box } from '../../components/Box'
import { BreadcrumbItem, Breadcrumbs } from '../../components/Breadcrumbs'
import { Flex } from '../../components/Flex'
import { NavPills, NavPillsItem, ResponsiveNavPills } from '../../components/NavPills'
import { Title } from '../../components/Text'
import { brkmax } from '../../components/theme'
import { useViewportSize } from '../../hooks/useViewportSize'

type Props = {
  title: string
  menuItems: NavPillsItem[]
  children: React.ReactNode | React.ReactNode[]
  topBackground?: React.ReactNode
  bottomBackground?: React.ReactNode
  breadcrumbs?: BreadcrumbItem[]
}

const Wrapper = styled(Flex)`
  position: relative;
`

const ContentContainer = styled(Box)`
  position: relative;
  z-index: 10;
`

const TopBackgroundWrapper = styled.div`
  position: absolute;
  top: -125px;
  right: -150px;
  width: 250px;
  height: 250px;
  ${brkmax(
    1,
    css`
      right: -130px;
    `
  )}

  ${brkmax(
    0,
    css`
      right: -65px;
    `
  )}
`

const BottomBackgroundWrapper = styled.div`
  position: absolute;
  bottom: -150px;
  left: -200px;
  width: 250px;
  height: 250px;

  ${brkmax(
    1,
    css`
      left: -175px;
    `
  )}

  ${brkmax(
    0,
    css`
      left: -150px;
      bottom: -120px;
    `
  )}
`

const PageTitle = styled(Title)`
  ${brkmax(
    0,
    css`
      display: none;
    `
  )}
`

export const AccountPageWrapper = ({
  title,
  menuItems,
  children,
  topBackground,
  bottomBackground,
  breadcrumbs
}: Props) => {
  const v = useViewportSize()
  return (
    <Wrapper flexDirection="column">
      {topBackground && <TopBackgroundWrapper>{topBackground}</TopBackgroundWrapper>}
      {bottomBackground && <BottomBackgroundWrapper>{bottomBackground}</BottomBackgroundWrapper>}
      {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
      <PageTitle level="extraLarge">{title}</PageTitle>
      <Flex flexWrap="wrap" pt="40px">
        {!_.isEmpty(menuItems) && (
          <Flex width={[1, 2 / 8]} flexDirection="column" pr={[0, 2, 4]}>
            <Space direction="vertical">
              {(v?.isMobile || v?.isTablet) && <ResponsiveNavPills items={menuItems} />}
              {(v?.isDesktop || v?.isWide) && <NavPills items={menuItems} />}
            </Space>
          </Flex>
        )}
        <ContentContainer width={[1, 6 / 8]} pt={[2, 0, 0]}>
          {children}
        </ContentContainer>
      </Flex>
    </Wrapper>
  )
}
